import { index, getEntities } from "src/api/audit-logs";

import AuditLogsDrawer from "src/modules/audit-logs/components/AuditLogsDrawer.vue";
import AuditLogDetailsDrawer from "src/modules/audit-logs/components/AuditLogDetailsDrawer.vue";
import TimelinesDrawer from "src/components/TimelinesDrawer.vue";

const getInitialState = () => ({
  log: {},
  logs: [],
  entity: {},
  logTrail: [],
  actionAreas: [],
});

export const useAuditLogsStore = defineStore("audit-logs", () => {
  const { state: auditLogsDrawerState, toggle: toggleAuditLogsDrawer } =
    useDrawer({
      component: AuditLogsDrawer,
    });

  const {
    state: auditLogDetailsDrawerState,
    toggle: toggleAuditLogDetailsDrawer,
  } = useDrawer({
    component: AuditLogDetailsDrawer,
  });

  const { state: timelinesDrawerState, toggle: toggleTimelinesDrawer } =
    useDrawer({ component: TimelinesDrawer });

  const state = reactive(getInitialState());

  const filters = ref({
    event_id: null,
    accept: null,
    entity: null,
    entity_id: null,
    action: null,
    event_time_lte: null,
    event_time_gte: null,
    executor_id: null,
  });

  const { filter, pagination, params } = usePagination(filters);

  const getAuditLogs = async (options, append = false) => {
    options = unref(options);

    if (options?.filters) {
      filters.value = options?.filters;

      delete options.filters;
    }

    const response = await index({
      params: unref(params),
      ...options,
    });

    if (append) {
      state.logs = [...state.logs, ...response.data.data.data];
    } else {
      state.logs = Array.isArray(response?.data?.data?.data)
        ? response?.data?.data?.data
        : [];
    }

    pagination.value.rowsNumber = response?.data?.data?.count;

    return response;
  };

  const getEntityAndUserLogs = async (options) => {
    options = unref(options);

    const response = await index(options);

    const shouldAppend = options?.params?.offset > 0;

    if (shouldAppend) {
      state.logTrail = [...state.logTrail, ...response.data.data.data];
    } else {
      state.logTrail = response?.data?.data?.data || [];
    }

    state.entity = response?.data?.data?.entity || {};

    return response;
  };

  const getActionAreaList = async (options) => {
    const response = await getEntities(options);

    state.actionAreas = response?.data?.data || [];

    return response;
  };

  const resetAuditDetails = async () => {
    state.logTrail = [];
  };

  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return {
    auditLogsDrawerState,
    toggleAuditLogsDrawer,
    auditLogDetailsDrawerState,
    toggleAuditLogDetailsDrawer,
    timelinesDrawerState,
    toggleTimelinesDrawer,

    filter,
    filters,
    params,
    pagination,

    ...toRefs(state),

    getAuditLogs,
    getActionAreaList,
    getEntityAndUserLogs,
    resetAuditDetails,
    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuditLogsStore, import.meta.hot));
}
